<template>
    <div class="selectfield" :id="fieldId">
        <label class="label" :for="fieldId"
            ><span>{{ label }}</span></label
        >
        <div class="select--wrap">
            <select
                @change="selectOnChange($event.target.value, fieldId)"
                :name="fieldId"
                :id="fieldId"
                :disabled="disabled"
            >
                <option v-if="placeholder" selected disabled>{{ placeholder }}</option>
                <option v-for="option of options" :key="option" :value="JSON.stringify(option)">
                    {{ option['name'] }}
                </option>
            </select>
        </div>
    </div>
</template>

<!-- Commenting here -->

<script>
export default {
    name: 'SelectField',
    data() {
        return {}
    },
    props: {
        selectOnChange: Function,
        label: String,
        fieldId: String,
        placeholder: String,
        disabled: Boolean,
        options: Array,
        optionLabel: String,
    },
    mounted() {},
}
</script>

<style scoped></style>
